module.exports = __webpack_public_path__ + "static/cf-med-italic-ext-64357065497c7a3c19309fb223b2bde1.eot";